import { RouteProps } from 'react-router'
import { matchPath } from 'react-router-dom'
import loadable from '@loadable/component'
import withRoot from 'CONTAINERS/withRoot'
import { Store } from 'typesafe-actions'

const Home = loadable(() => import(/* webpackChunkName: "Home" */ 'PAGES/Home'), {
  ssr: false,
})
const About = loadable(() => import(/* webpackChunkName: "About" */ 'PAGES/About'))
const SpeedTest = loadable(
  () => import(/* webpackChunkName: "SpeedTest" */ 'PAGES/SpeedTest'),
  {
    ssr: false,
  },
)
const NoMatch = loadable(() => import(/* webpackChunkName: "NoMatch" */ 'PAGES/NoMatch'))

export type ExtendRouteProps = RouteProps & {
  withAuth?: boolean
  loadData?: (ctx: any, store: Store, match: ReturnType<typeof matchPath>) => Promise<any>
}

const initRoutes: ExtendRouteProps[] = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/speedtest',
    component: SpeedTest,
  },
  {
    path: '/about',
    component: About,
  },
  { path: '*', component: NoMatch },
]

const routes: ExtendRouteProps[] = initRoutes.map((item) => ({
  ...item,
  component: withRoot(item.component!),
}))

export default routes
